var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 21.875V19.7917C20.8333 18.6866 20.3944 17.6268 19.613 16.8454C18.8316 16.064 17.7717 15.625 16.6667 15.625H8.33334C7.22827 15.625 6.16846 16.064 5.38706 16.8454C4.60566 17.6268 4.16667 18.6866 4.16667 19.7917V21.875",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.4583C14.8012 11.4583 16.6667 9.59285 16.6667 7.29167C16.6667 4.99048 14.8012 3.125 12.5 3.125C10.1988 3.125 8.33334 4.99048 8.33334 7.29167C8.33334 9.59285 10.1988 11.4583 12.5 11.4583Z",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.393de9d6401091ac06f67a0c55253a75.svg";
export { ForwardRef as ReactComponent };